export default __webpack_public_path__ + "static/media/bg_8.766f2224.png";